import { createSelector } from 'reselect'
import widgetTypes from 'helpers/enums/widgetTypes'

const getStore = state => state.store

const storeCarouselSelector = createSelector(
	[ getStore ],
	storeData => {
		let highlightWidget = {}
		if (storeData && storeData.catalog && storeData.catalog.widgets) {
			highlightWidget = storeData.catalog.widgets.filter(value => value.type === widgetTypes.HIGHLIGHT)
		}
		const entities = (highlightWidget && highlightWidget[0] && highlightWidget[0].entities) ? highlightWidget[0].entities : []

		return {
			entities,
		}
	}
)

export default storeCarouselSelector
